import React, { useEffect, useState } from "react";
import PopupAHSF from "../../Components/PopupAHSF";
import TableAHSF from "../../Components/TableAHSF";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import {
  DeletePR_LessonsLearnedById,
  GetSpecificRowNoteLessonsLearned,
} from "../../Redux/Reducers/ReportStage/LessonsLearned";
import AddEditeLessonsLearned from "./AddEditeLessonsLearned";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const LessonsLearnedPage = (props) => {
  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);
  const [pR_LessonsLearnedId, setpR_LessonsLearnedId] = useState(null);
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      OneSpecificRowNoteLessonsLearned:
        state.LessonsLearned.OneSpecificRowNoteLessonsLearned,
    };
  });

  console.log(
    state.OneSpecificRowNoteLessonsLearned?.incrementNumber,
    "stateeee"
  );
  

  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);
  useEffect(() => {
    dispatch(
      GetSpecificRowNoteLessonsLearned({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "455265a0-6d80-41ce-9efa-cce98a4dac90",
      })
    );
    console.log(stageGuid,"aaaaaa");
  }, []);
  
  //   const shouldDisableFields = false;
  const RequestAccessor = [
    {
      KeyName: "lessonsLearnedDescription",
      ShowStatus: true,
      NmaeColumn: "الدروس المستفادة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const OtherMainBtns = [
    {
      Click: async (e) => {
        setpR_LessonsLearnedId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: props.canEdit ? "bi bi-pencil-square" : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },

    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          // Callback triggered after user interacts with the popup.
          if (res.isConfirmed == true) {
            // If the user confirms the action:
            const deleted = await dispatch(
              DeletePR_LessonsLearnedById(e.target.value)
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: props.canEdit,
    },
  ];

  const RequestsColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataAddStatus,

    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        {" "}
        <AddEditeLessonsLearned />{" "}
      </div>
    ),

    title: "الدروس المستفادة",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },

    componentBody: (
      <div>
        <AddEditeLessonsLearned
          pR_LessonsLearnedId={pR_LessonsLearnedId}
          BtnClick="edit"
          shouldDisableFields={!props.canEdit}
        />
      </div>
    ),

    title: "الدروس المستفادة",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"pR_LessonsLearnedId"}
        valueButtonAction={"pR_LessonsLearnedId"}
        URL={`api/PR_LessonsLearned/GetListPR_LessonsLearnedByStageId`}
        UrlBody={{
          reportsStagesGuid: props.pR_ReportsStagesGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الدروس المستفادة"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={props.canEdit}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"الدروس المستفادة"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  );
};

export default LessonsLearnedPage;
